import React, { useState } from 'react';
import { Alert, Button } from 'antd';
import { Gift } from 'lucide-react';
import SignupModal from './SignupModal';
import { useTranslation } from 'react-i18next';

const FreeTrialBanner = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="py-8 bg-green-50">
      <div className="container mx-auto px-6">
        <Alert
          message={
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <Gift className="text-primary mr-3" size={24} />
                <span className="text-lg font-semibold">
                  {t('freeTrial.bannerText')}
                </span>
              </div>
              <Button 
                type="primary" 
                className="bg-primary border-primary"
                onClick={() => setModalOpen(true)}
              >
                {t('common.startFreeTrial')}
              </Button>
            </div>
          }
          type="success"
          showIcon={false}
          className="border-primary/20 bg-green-50"
        />
        
        <SignupModal 
          open={modalOpen} 
          onClose={() => setModalOpen(false)} 
        />
      </div>
    </div>
  );
};

export default FreeTrialBanner;
